/** Offset for fixed header — keep in sync with main content `mt` / #services scroll-margin */
export const HASH_SCROLL_RETRY_MS = 100;
export const HASH_SCROLL_MAX_ATTEMPTS = 20;
export const HASH_SCROLL_INITIAL_DELAY_MS = 150;

export function scrollToHash(hash, options = {}) {
  const id = String(hash || "").replace(/^#/, "");
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({
    behavior: options.behavior ?? "smooth",
    block: "start",
  });
  return true;
}

/**
 * Scroll after SPA navigation when target may not be mounted yet (FadeInOnScroll, etc.).
 */
export function scrollToHashWhenReady(hash, options = {}) {
  const {
    initialDelay = HASH_SCROLL_INITIAL_DELAY_MS,
    interval = HASH_SCROLL_RETRY_MS,
    maxAttempts = HASH_SCROLL_MAX_ATTEMPTS,
    behavior = "smooth",
  } = options;

  let attempts = 0;
  let timeoutId;
  let intervalId;

  const tryScroll = () => {
    attempts += 1;
    if (scrollToHash(hash, { behavior })) {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
      return true;
    }
    if (attempts >= maxAttempts) {
      if (intervalId) clearInterval(intervalId);
      return false;
    }
    return false;
  };

  timeoutId = setTimeout(() => {
    if (tryScroll()) return;
    intervalId = setInterval(tryScroll, interval);
  }, initialDelay);

  return () => {
    clearTimeout(timeoutId);
    if (intervalId) clearInterval(intervalId);
  };
}
